export const DailyQuestMobile = {
	name: 'quest_daily',
	position: {
		x: 0,
		y: 0
	},
	components: [
		{
			name: 'quest_featured_img',
			type: 'Sprite',
			img: 'quest_featured_img',
			position: { x: -10, y: -10 },
			scale: {
				x: 0.58,
				y: 0.58
			}
		},
		{
			name: 'itemheader',
			type: 'Text',
			position: { x: 140, y: 6 },
			text: 'QUEST_DAILY_TITLE_MOBILE_0'
		},
		{
			name: 'icon',
			type: 'Sprite',
			img: 'trophy_icon',
			position: { x: 140, y: 40 }
		},
		{
			name: 'itemsubtitle',
			type: 'Text',
			position: { x: 170, y: 38 },
			text: 'QUEST_DAILY_SUBTITLE_MOBILE'
		},
		{
			name: 'icon',
			type: 'Sprite',
			img: 'clock_icon',
			position: { x: 360, y: 40 }
		},
		{
			name: 'itemdesc',
			type: 'Text',
			position: { x: 390, y: 38 },
			text: 'QUEST_TIMER_ICON_MOBILE'
		}
	]
};
